/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ObservableComponentBase from './ObservableComponentBase';

/** @hidden */
const ccclass = cc._decorator.ccclass;
/** @hidden */
const property = cc._decorator.property;

/** Implementation of [[ObservableComponentBase]] for observing boolean values. */
@ccclass
export default class ObservableBooleanComponent extends ObservableComponentBase<boolean>
{
    /** The boolean value to observe. */
    protected value: boolean = false;

    /** Should the boolean value start true or false. */
    @property({ visible: true })
    private _startValue: boolean = false;
    /** Accessor for the start value. */
    public get StartValue(): boolean { return this._startValue; }

    public MaxValue: boolean = true;
    public MinValue: boolean = false;

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.Value = this._startValue;
    }
}
